import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.title',
    defaultMessage: 'Bulk assign supplier',
  },
  selectTasks: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.selectTasks',
    defaultMessage: '1. Select tasks',
  },
  selectSupplier: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.selectSupplier',
    defaultMessage: '2. Select supplier',
  },
  details: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.details',
    defaultMessage: '3. (Optionally) Overwrite task details',
  },
  detailsDescription: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.detailsDescription',
    defaultMessage: 'Anything you leave blank keeps the value each task already has. Anything you fill in is written to every selected task.',
  },
  brief: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.brief',
    defaultMessage: 'Notification message',
  },
  briefDescription: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.briefDescription',
    defaultMessage: 'Sent to the supplier and written to every selected task. Leave empty to keep the briefs already on the tasks.',
  },
  cost: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.cost',
    defaultMessage: 'Cost',
  },
  price: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.price',
    defaultMessage: 'Price',
  },
  deadline: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.deadline',
    defaultMessage: 'Deadline',
  },
  productInfo: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.productInfo',
    defaultMessage: 'Product Info',
  },
  productInfoMixedTypes: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.productInfoMixedTypes',
    defaultMessage: 'Product Info can only be set when every selected task is the same type. The tasks keep the Product Info they already have.',
  },
  task: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.task',
    defaultMessage: 'Task',
  },
  supplier: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.supplier',
    defaultMessage: 'Supplier',
  },
  unassigned: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.unassigned',
    defaultMessage: 'Not assigned',
  },
  noTasks: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.noTasks',
    defaultMessage: 'None of the selected items are tasks. Select one or more tasks and try again.',
  },
  allAssigned: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.allAssigned',
    defaultMessage: 'All selected tasks already have a supplier assigned.',
  },
  currencyMismatch: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.currencyMismatch',
    defaultMessage: 'Cost currency ({costCurrency}) is not the same as the supplier currency ({supplierCurrency})',
  },
  supplierHasNoCurrency: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.supplierHasNoCurrency',
    defaultMessage: '{supplier} has no currency on their profile - the cost defaults to {costCurrency}',
  },
  conversionFailed: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.conversionFailed',
    defaultMessage: 'Could not convert the cost from {costCurrency} to {priceCurrency}, so cost and price could not be compared.\n\nAssign anyway?',
  },
  supplierIsUnavailable: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.supplierIsUnavailable',
    defaultMessage: 'This supplier is marked unavailable: {unavailability}',
  },
  submit: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.submit',
    defaultMessage: 'Assign to {count} tasks',
  },
  confirmAssign: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.confirmAssign',
    defaultMessage: 'Assign {supplier} to {count} tasks?\n\n{changes}\n\nEverything else keeps the value each task already has. The supplier is notified straight away.\n\nAre you sure everything relevant is filled in on the tasks?',
  },
  confirmNoChanges: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.confirmNoChanges',
    defaultMessage: 'You are only setting the supplier.',
  },
  confirmChanges: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.confirmChanges',
    defaultMessage: 'These will be written to every selected task:{changes}',
  },
  loading: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.loading',
    defaultMessage: 'Assigning..',
  },
  assigned: {
    id: 'containers.OrderPage.components.BulkAssignSupplierModal.assigned',
    defaultMessage: 'Supplier assigned to {count} tasks',
  },
})
